import React, { useState, useEffect, useRef } from 'react';
import { Typography } from '@material-ui/core';
import { GetApp, Cancel } from '@material-ui/icons';
import { TextButton, Button } from 'm2m.components';
import { defaultAcceptableFileTypes } from 'components/uploadDocs';
import { v4 as uuid } from 'uuid';
import {Comprovante} from 'common/genericTypes';
import { OfertaPrimariaInvestidor } from 'store/modules/operacoes/registro';

interface Props {
  investidor: OfertaPrimariaInvestidor | null;
  anexo?: Comprovante;
  onAdd: (anexo: Comprovante) => void;
  onDelete: (anexo: Comprovante) => void;
}

const ComprovanteComponent: React.FC<Props> = (props) => {
  const { investidor, anexo, onAdd, onDelete } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const handleAnexoDelete = () => {
    onDelete(anexo!);
  };

  const openFileDialog = () => {
    inputRef?.current?.click();
  };

  const isValidFileType = (file: File): boolean => {
    return defaultAcceptableFileTypes.some((type) => file.type === type);
  };

  const onInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files ? event.target.files?.[0] : null;
    if (!newFile) return;

    if (!isValidFileType(newFile)) {
      inputRef!.current!.value = '';
      return;
    }

    const newAttachment: Comprovante = {
      id: uuid(),
      investidorId: investidor!.investidorId,
      file: newFile,
    };

    onAdd(newAttachment);
  };

  if (anexo) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', maxWidth: '100%' }}>
        <div style={{ overflow: 'hidden' }}>
          <Typography variant="subtitle1">{anexo.file?.name ?? anexo.remoteFileInfo?.fileName ?? ''}</Typography>
        </div>
        <TextButton onClick={() => handleAnexoDelete()} startIcon={<Cancel />}>
          {'Remover'}
        </TextButton>
      </div>
    );
  } else {
    return (
      <div>
        <TextButton onClick={openFileDialog}>{'Anexar Comprovante'}</TextButton>
        <input
          ref={inputRef}
          type="file"
          accept={defaultAcceptableFileTypes.join(',')}
          multiple
          style={{ display: 'none' }}
          onChange={onInputChange}
        />
      </div>
    );
  }

};

export default ComprovanteComponent;
